import { Box, Select, SelectProps, ThemeUIStyleObject } from 'theme-ui';
import { ReactNode, useRef } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { desaturate, lighten } from '@theme-ui/color';

interface DropdownFieldItem {
  value: any,
  label?: ReactNode,
  content?: ReactNode
}

interface PropsWithSx extends Object {
  sx?: ThemeUIStyleObject
}

interface DropdownFieldProps extends SelectProps {
  items: Array<DropdownFieldItem>,
  required?: boolean;
  dropdownContainerProps?: PropsWithSx;
}

function Item({ item, onSelect }) {
  return (
    <DropdownMenu.Item
      key={item.value}
      sx={{
        outline: 0,
        cursor: 'pointer',
        '&[data-highlighted]': {
          backgroundColor: t => lighten(desaturate('primary', 0.35)(t), 0.45)(t)
        }
      }}
      onSelect={() => onSelect(item)}
    >
      {item.content || item.label}
    </DropdownMenu.Item>
  );
}

export default function DropdownField({
  items,
  value,
  required = false,
  dropdownContainerProps: {
    sx: dowpdownContainerSx = {},
    ...otherDropdownContainerProps
  } = {},
  ...props
}: DropdownFieldProps) {
  const event = new Event('change', { bubbles: true });

  const ref = useRef<HTMLSelectElement>();

  const selected = item => {
    if (ref.current) {
      ref.current.value = item.value;
      ref.current.dispatchEvent(event);
    }
  };

  return (
    <DropdownMenu.Root
      onOpenChange={x => {
        console.log({x});
      }}
    >
      <DropdownMenu.Trigger asChild>
        <Select
          ref={ref}
          value={value}
          {...props}
        >
          {items.map(item =>
            <option
              key={item.value}
              value={item.value}
            >
              {item.label}
            </option>
          )}
        </Select>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="start"
        >
          <Box
            sx={{
              backgroundColor: '#fff',
              padding: 2,
              border: '1px solid #333',
              borderRadius: '4px',
              my: '2px',
              p: 0,
              ...dowpdownContainerSx,
              maxHeight: 200, // TODO: make a prop?
              overflowY: 'scroll'
            }}
            {...otherDropdownContainerProps}
          >
            {items.filter(item => item.value !== value).map(item =>
              <Item
                key={item.value}
                item={item}
                onSelect={selected}
              />
            )}
          </Box>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
